<div class="card">
  <div class="card-body">
    <div class="row not-authorized align-items-center justify-content-center">
      <div class="col-auto">
        <h4>Você não tem permissão para acessar a página ou área solicitada</h4>
        <div class="mt-4 text-center">
          <button routerLink="/" type="button" class="btn btn-dark">
            Retornar para a tela inicial
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
